import styled from 'styled-components/macro';

import Button from 'components/Button/Button';
import FlexContainer from 'components/FlexContainer/FlexContainer';
import Typography from 'components/Typography/Typography';

type SubmitButtonPropsT = {
  isSuccess: boolean;
};
export const ProfileFormStyled = styled.form`
  margin: 2rem;
  padding: 1rem;
  border-top: ${({ theme }) => `${theme.borders.sm} ${theme.colors.primary.variant6}`};
  border-bottom: ${({ theme }) => `${theme.borders.sm} ${theme.colors.primary.variant6}`};
`;

export const InputStyled = styled.div`
  margin-bottom: 1rem;
  border: ${({ theme }) => `${theme.borders.xs} ${theme.colors.primary.variant6}`};
`;

export const UserFormStyled = styled.div`
  margin-top: 1.5rem;
  ${({ theme }) => `
    ${theme.devices.tablet} {
      margin-left: 1rem;
    }
    ${theme.devices.smallDesktop} {
      margin-top: 0;
      margin-left: 0;
      padding: 1.875rem;
      width: 70%;
    }
  `}
`;

export const LogoWrapStyled = styled.div`
  display: flex;
  justify-content: center;
`;

export const FormWrapStyled = styled.div`
  min-width: 300px;
  max-width: 900px;
  margin-top: 1.875rem;
`;

export const InputWrapStyled = styled.div`
  margin: 0.5rem 0 1.875rem;
  input {
    border: ${({ theme }) => `${theme.borders.sm} ${theme.colors.primary.variant3}`};
    margin-bottom: 0.25rem;
    &.PhoneInputInput {
      border: none;
    }
  }
`;

export const ErrorMessageStyled = styled(Typography)`
  margin-bottom: 1.25rem;
`;

export const WarningStyled = styled(Typography)`
  margin: 1rem 0 2rem;
  color: ${({ theme }) => theme.colors.primary.variant8};
`;

export const CTAContainerStyled = styled(FlexContainer)`
  gap: 0.5rem;
  white-space: pre;
`;

export const SubmitButtonStyled = styled(Button)<SubmitButtonPropsT>`
  min-width: 170px;
  border: none;
  background-color: ${({ isSuccess, theme }) =>
    isSuccess ? theme.colors.secondary.variant1 : theme.colors.primary.variant1};
`;
